import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setBrandCateIdAction, setActiveBrandCateIdAction } from '../../modules/common/cateModule';
import { setCurPageAction } from '../../modules/common/prodModule';
import TagBtn from '../common/button/TagBtn';


const EsApplyCateItemListBlock = styled.div`
`;

/**
 * 카테고리 아이템 컨트롤러 
 * 
 */
const EsApplyCateItemList = ({ categoryItems, loading, error, evtHandler }) => {

    const [isShowBtm, setShowBtm] = useState(false);
    const [curCateId, setCurCateId] = useState(0);
    const [selCateIdList, setSelCateIdList] = useState([]);
    const dispatch = useDispatch();

    // selCateIdList 가 변경시 마다 Store에 저장 
    useEffect(() => {
        // 선택된 카테고리 저장 
        dispatch(setBrandCateIdAction(selCateIdList));
        // 선택된 카테고리중 Active 카테고리 저장 - 여기는 모두 저장 
        dispatch(setActiveBrandCateIdAction(selCateIdList));

        // 상품 page 정보 Reset 
        // dispatch(setCurPageAction(1));

    }, [dispatch, selCateIdList]);

    if (error) {
        return (<EsApplyCateItemListBlock>
        </EsApplyCateItemListBlock>);
    };

    // 1 Depth 카테고리 Icon Click 처리 
    const handleIconClick = (id) => {
        // console.log("onClick : " + id)

        // 최초 하단이 표시 되지 않았을 경우에만 표시
        if (isShowBtm === false) {
            setShowBtm(!isShowBtm);
        }

        // 카테고리 아이디 설정 
        setCurCateId(id);
    }

    // Second Category 선택 처리 
    const handleScndCateClick = (id) => {
        const targetId = curCateId + "0" + id;
        const searchIdx = selCateIdList.indexOf(targetId);

        // 추가 되어 있지 않으면 
        if (searchIdx === -1) {
            setSelCateIdList([...selCateIdList, targetId]);
        } else {
            setSelCateIdList(
                [
                    ...selCateIdList.slice(0, searchIdx),
                    ...selCateIdList.slice(searchIdx + 1, selCateIdList.length)
                ]
            );
        }

    }

    // 다음 버튼 선택시 처리 
    const handleNextBtnClick = () => {
        if (selCateIdList.length > 0) {
            evtHandler(selCateIdList);
        }
    }

    // Second Category Active 확인 처리 
    const checkVisible = (id) => {
        const targetId = curCateId + "0" + id;
        return selCateIdList.indexOf(targetId);
    }

    // 2 Depth 카테고리 Element 만들기 
    const makeScndCateList = () => {

        // 선택된 아이콘이 있는 경우에만 render
        if (curCateId !== 0) {
            const targetCategory = categoryItems.filter(function (item) {
                return item.id === curCateId
            });
            const scndCategory = targetCategory[0].cate2;
            const length = scndCategory.length;
            return (
                scndCategory.map(cateItem => (
                    <TagBtn key={cateItem.id}
                        active={checkVisible(cateItem.id) !== -1}
                        float='left' onClick={handleScndCateClick}
                        onDelClick={handleScndCateClick}
                        text={cateItem.cate_name} isSmall={true} value={cateItem.id}
                        width={(100 / length) + "%"} />
                )
                ));
        } else {
            return "<div></div>";
        }

    }

    // 카테고리에 선택된 갯수 저장 
    const getSelectedCnt = (id) => {
        let cnt = 0;
        selCateIdList.forEach(element => {
            if (id === Math.floor((element / 100))) {
                cnt++;
            }
        });
        if (cnt === 0) return '';
        return cnt;
    }

    // 리스트 표시 
    if (!loading && categoryItems !== null) {
        return (
            <EsApplyCateItemListBlock>
                <div className="aa-top">
                    <ul className="cate_select-list sz-wrap clearfix">
                        {
                            categoryItems.map(cateItem => (
                                <li key={cateItem.id} onClick={() => { handleIconClick(cateItem.id) }} className={curCateId === cateItem.id ? "active" : ""} >
                                    <p className="hover_circle">
                                        <img src={"../assets/images/icon/" + cateItem.cate_img} alt="" />
                                    </p>
                                    <span className="cate_name">{cateItem.cate_name}
                                        {getSelectedCnt(cateItem.id) > 0 ? ' (' : ''}
                                        <span className="font-mont"> {getSelectedCnt(cateItem.id)} </span>
                                        {getSelectedCnt(cateItem.id) > 0 ? ')' : ''}
                                    </span>
                                </li>

                            ))
                        }
                    </ul>
                </div>
                <div className="aa-btm border" style={{ display: (isShowBtm) ? 'block' : 'none' }}>
                    <div className="tag_s-box margin_b-40 clearfix">
                        {
                            makeScndCateList()
                        }
                    </div>
                    <div className="text_center">
                        <button type="button"
                            id="itemApplyNextBtn" className={selCateIdList.length > 0 ? "s-btn black-btn" : "s-btn lgray-btn"}
                            onClick={handleNextBtnClick}
                        >다음</button>
                    </div>
                </div>
            </EsApplyCateItemListBlock>
        );
    } else {
        return (<EsApplyCateItemListBlock>
        </EsApplyCateItemListBlock>);
    }

};

export default EsApplyCateItemList;